import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Tool, useBookmarkToolMutation } from '__generated__/api-types-and-hooks'
import { updateBookmarkToolAction } from 'store/actions/clients'

const useBookmark = (tool: Tool) => {
  const { toolSubTab } = useParams()
  const dispatch = useDispatch()
  const {
    mutate: bookmarkTook,
    isLoading: isBookmarkingInProgress,
    data: bookmarkTookResponse,
  } = useBookmarkToolMutation()

  const handleClick = (tool: Tool) => {
    bookmarkTook({
      input: {
        isBookmarked: !tool?.isBookmarked,
        toolId: tool.id!,
      },
    })
  }

  useEffect(() => {
    if (bookmarkTookResponse?.bookmarkTool && !bookmarkTookResponse?.bookmarkTool?.error) {
      dispatch(
        updateBookmarkToolAction({
          toolId: tool.id!,
          isBookmarked: !tool?.isBookmarked,
          toolSubTab,
          bookMarkResponseData: bookmarkTookResponse?.bookmarkTool?.data as Tool,
        })
      )
    }
    // eslint-disable-next-line
  }, [bookmarkTookResponse])

  return { isBookmarkingInProgress, handleClick }
}

export default useBookmark
